import React from "react";
import { Link } from "react-router-dom";
import { VISUALLY_HIDDEN } from "../../shared/visually-hidden";

// The start page is all live widgets (a game window, buttons, a countdown), so
// on its own it has no heading and next to no text: nothing for a screen reader
// to announce or a search engine to read. This is that heading and a two line
// summary, visually hidden so the start page looks exactly as designed. It is
// also rendered into the built index.html at prerender time
// (scripts/prerender.mjs), so a crawler that runs no JS reads the same text.
// Keep it short (it is a page summary, not hidden copy) and SSR-safe: no
// hooks, no auth, no browser globals.

export default function HomeIntro() {
  return (
    <section style={VISUALLY_HIDDEN} aria-labelledby="home-intro-title">
      <h1 id="home-intro-title">Achtung Royale: play Achtung, die Kurve! online</h1>
      <p>
        A free browser version of the 1995 classic Achtung, die Kurve! (Zatacka): steer with two
        keys, dodge all the worms and be the last one alive. Jump into Play Now, the 30 player Royale,
        Ranked 1 vs 1 or create a Game Room to play with your friends. You can also play locally up
        to 10 players on one keyboard.
      </p>
      <nav aria-label="More">
        <Link to="/local">Local play</Link> <Link to="/leaderboard">Leaderboard</Link>{" "}
        <Link to="/news">News</Link> <Link to="/about">About</Link>
      </nav>
    </section>
  );
}
